import logo from './logo.svg';
import './App.css';
import Resturant from'./compo/Resturant';
function App() {
  return (
    <div className="App">
 <Resturant/>
    </div>
  );
}

export default App;
